import { render } from "./IncomeEdit.vue?vue&type=template&id=b0bc2df6"
import script from "./IncomeEdit.vue?vue&type=script&lang=js"
export * from "./IncomeEdit.vue?vue&type=script&lang=js"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__